export default __webpack_public_path__ + "static/media/favicon.266cc25d.ico";